import dayjs from "dayjs";
import { showAlert } from "../../components/containers/Alert";
import { DATE_CONSTANTS } from "../constants/date";

export const formatDate = (
  date: string | Date,
  format = DATE_CONSTANTS.DATE_FORMAT
) => {
  return dayjs(date).format(format);
};

export const formatDateTime = (date: string | Date) => {
  return formatDate(date, DATE_CONSTANTS.DATETIME_FORMAT as any);
};

export const getDateRange = (days: number) => {
  const end: any = dayjs();
  const start: any = end.subtract(days, "days");

  return {
    startDate: formatDateTime(start.startOf("day")),
    endDate: formatDateTime(end.endOf("day")),
  };
};

export const validateDateRange = (
  startDate?: string | null,
  endDate?: string | null,
  maxDays: number = DATE_CONSTANTS.MONTH
): boolean => {
  if (!startDate || !endDate) {
    showAlert("날짜를 입력해주세요.");
    return false;
  }

  const start = dayjs(startDate);
  const end = dayjs(endDate);
  const diffDays = end.diff(start, "days");

  if (!start.isValid() || !end.isValid()) {
    showAlert("유효하지 않은 날짜입니다.");
    return false;
  }

  if (end.isBefore(start)) {
    showAlert("종료 날짜는 시작 날짜보다 이후여야 합니다.");
    return false;
  }

  if (diffDays > maxDays) {
    showAlert(
      `조회 기간은 ${
        maxDays === 93 ? "3개월" : `${maxDays}일`
      }을 초과할 수 없습니다.`
    );
    return false;
  }

  return true;
};
